export default __webpack_public_path__ + "static/media/typesTraining.72822ceb.svg";